export { default as HelpPages } from './list'



// WEBPACK FOOTER //
// ./src/internal-app/pages/administration/helpPages/index.js